// Definimos los tokens de diseño para que AntD coincida con la marca REVI
export const reviTheme = {
  token: {
    colorPrimary: "#007BFF", // Azul REVI
    colorSuccess: "#28A745",
    colorWarning: "#FD7E14",
    colorError: "#DC3545",
    borderRadius: 8,
    fontFamily: "'Roboto', sans-serif", // Asumiendo que usas Roboto
  },
  components: {
    Card: {
      headerFontSize: 16,
      bodyPadding: 12,
    },
    Button: {
      fontWeight: 600,
    },
  },
};
